import {KFZ_ACTIONS} from "../actions/types";
import {updateCache} from "ith-redux-helpers";
import {UPDATE_KFZ} from "../actions";
import {uniqify} from "ah-lib";

const defaulstState = {
	list: []
};

export default (state = defaulstState, {type, list, kfz_id, models, model, cache=true}) => {
	const cached = (key) => cache ? updateCache(key) : undefined;
	switch( type ) {
		case KFZ_ACTIONS.SET:
			return {
				...state,
				list: uniqify(state.list, list.map(kfz => { kfz.models = []; return kfz; }))(el => el.kfz_id),
				...cached(UPDATE_KFZ)
			};
		case KFZ_ACTIONS.REMOVE:
			return {
				...state,
				list: state.list.filter(car => car.kfz_id !== kfz_id),
				...cached(UPDATE_KFZ)
			};
		case KFZ_ACTIONS.SET_MODELS:
			return {
				...state,
				list: state.list.map(car => {
					if ( car.kfz_id === kfz_id ) {
						car = {
							...car,
							models: uniqify(car.models, models)(model => model.model_id)
						}
					}
					return car;
				}),
				// ...cached(UPDATE_KFZ)
			};
		case KFZ_ACTIONS.REMOVE_MODEL:
			return {
				...state,
				list: state.list.map(car => {
					if (car.kfz_id === kfz_id) {
						car = {
							...car,
							models: car.models.filter(m => m.model_id !== model.model_id)
						}
					}
					return car;
				})
			};
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/kfzReducer.js